<script>
export default {
  name: 'Logout'
}
</script>



// WEBPACK FOOTER //
// src/components/login/Logout.vue